import React from "react";
import { door_types } from "../../../../lib/constant";

const TypeRadioGroup = ({ register, setValue,getValues }) => {
const {opening_direction,height,width} = getValues()

    return (
        <>
            {door_types.map((item) => (
                <div key={item?.name} className="group">
                    <div
                        key={item?.name}
                        className="relative flex flex-col items-center justify-center gap-2 group-has-[:checked]:bg-[#555454] p-3"
                    >
                        <img
                            className="size-14"
                            src={`/assets/door_lights/${opening_direction}/${item?.name}.png`}
                            alt={item?.name}
                        />
                        <input
                            className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer "
                            type="radio"
                            id="type"
                            value={item?.configuration}
                            {...register("configuration", {
                                onChange: (e) => {
                                    const selectedItem = door_types.find(
                                        (type) => type.configuration === e.target.value
                                    );
                                    setValue(
                                        "configuration_type",
                                        selectedItem?.configuration_type
                                    );
                                    if(e.target.value === "none") {
                                        setValue('aperture_height',height)
                                        setValue('aperture_width',width)
                                    }
                                },
                            })}
                        />
                        <p className='text-gray-600 text-xs uppercase group-has-[:checked]:text-white'>{item.display}</p>
                    </div>
                </div>
            ))}
        </>
    );
};

export default TypeRadioGroup;
